import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';

export const syncUtmTags =
  (utm?: Record<string, string>): AppThunk =>
  async (dispatch, getState, services) => {
    const { utmTagsService, userService, loggingService: logger, analyticsService } = services;

    try {
      const utmTags = utmTagsService.getUtmTags();
      await userService.updateUtmTags({ ...utmTags, ...utm });
      analyticsService.updateUserProperties({ ...utmTags, ...utm });
    } catch (e) {
      const err = normalizeError(e);
      logger.error(err);
    }
  };
